<template>
    <van-popup
            :value.sync="departmentSelectVisible"
            round
            position="bottom"
            :style="{ height: '77%' }"
            @click-overlay="handleClosePopup"
            v-if="departmentSelectVisible"
    >
        <div class="department_select_wrap">
            <div class="department_select_wrap_title">
                <van-icon @click="handleClosePopup" name="arrow-left" />
                <span class="title">选择部门</span>
                <span class="confirm_text" @click="handleClickConfirmSelect">确定</span>
            </div>
            <div class="department_select_content">
                <van-cascader active-color="rgba(57, 151, 242, 1)" :closeable="false" :field-names="cascaderFieldNames"  v-model="selectDepartmentId" title=""  :options="deparmentList" @change="handleChangeDepartment" />
            </div>
        </div>
    </van-popup>
</template>

<script>
import { GetDepartmentList } from "@/api";
export default {
    name: "DepartmentSelect",
    props: {

        departmentSelectVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            cascaderFieldNames: {
                text: 'relate_name',
                value: 'relate_id',
                children: 'children',
            },
            selectDepartmentId: null,
            selectDepartmentData: null,
            deparmentList:[]
        };
    },
    created() {
        this.getDepartmentList();
    },
    methods: {
        handleChangeDepartment({ value, selectedOptions, tabIndex }){

            this.selectDepartmentData = selectedOptions ? selectedOptions[selectedOptions.length - 1] : null;
        },
        handleClosePopup() {
            this.$emit("update:departmentSelectVisible", false);
        },
        handleClickConfirmSelect() {
            if(!this.selectDepartmentData){
                this.$toast('请选择部门')
                return false
            }
            this.$emit("success", this.selectDepartmentData);
            this.handleClosePopup();
        },
        getDepartmentList() {
            GetDepartmentList().then(res => {
                if (res.code === 200) {
                    this.deparmentList = res.data
                }
            })
        },
    },
};
</script>

<style lang="scss">
.department_select_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .department_select_wrap_title {
        flex-shrink: 0;
        padding: 0 16px;
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .van-icon-arrow-left {
            font-size: 24px;
            color: rgba(102, 102, 102, 1);
        }
        .title {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
        .confirm_text {
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(41, 144, 240, 1);
        }
    }
    .department_select_wrap_search {
        .van-search {
            padding: 0 16px;
            .van-search__content {
                border-radius: 6px;
                background: rgba(255, 255, 255, 1);

                border: 1px solid rgba(217, 217, 217, 1);
            }
            .van-icon-search {
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
            }
        }
    }
    .department_select_content {
        flex: 1;
        padding: 10px 0;
        overflow-y: auto;
        .van-cascader__header{
            display: none;
        }

    }
}
</style>
